'use client';

import { create } from 'zustand';

interface KakaobankExitStore {
  isExitConfirmOpened: boolean;
  openExitConfirm: () => void;
  closeExitConfirm: () => void;
}

//* 닫기 버튼과 안드로이드 back이 같은 종료 확인을 띄워야 해서 열림 상태를 컴포넌트 밖에 둔다
export const useKakaobankExitStore = create<KakaobankExitStore>((set) => ({
  isExitConfirmOpened: false,
  openExitConfirm: () => set({ isExitConfirmOpened: true }),
  closeExitConfirm: () => set({ isExitConfirmOpened: false }),
}));
